export default __webpack_public_path__ + "static/about-image-a406fa74a95018ad6b5e5bf955bd96c2.png";